export const promiseErrorCallbacks: { [key: string]: () => void } = {};

export const setPromiseErrorCallback = (eventName: string, callback: () => void) => {
  promiseErrorCallbacks[eventName] = callback;
};
